import React, { useEffect, useState } from 'react';

interface IComponentClientOnlyProps {
  children: React.ReactNode;
}

const ComponentClientOnly = ({
  children,
  ...delegated
}: IComponentClientOnlyProps) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return <React.Fragment {...delegated}>{children}</React.Fragment>;
};

export default ComponentClientOnly;
